import React, {Fragment} from 'react';
import autobind from 'autobind-decorator';
import {Col, FormControl, Row} from 'react-bootstrap';

import {BaseTableFilter} from "../../Common/Tables/BaseTableFilter";
import {service as OrganizationService} from "../../../Services/OrganizationService";
import {service as RelationshipService} from "../../../Services/RelationshipService";
import {service as ContactService} from "../../../Services/ContactService";

export class ContactsTableFilter extends BaseTableFilter {
    constructor(props) {
        super(props);

        this.setInitialState({
            relationships: [],
            organizations: [],
            organizationId: "",
            relationshipId: "",
            textFilter: ""
        });
    }

    @autobind
    loadData() {
        super.loadData();

        RelationshipService.Get().then(resp => this.setState({relationships: resp?.result || []}));
        OrganizationService.Get().then(resp => this.setState({organizations: resp?.result || []}));
    }

    @autobind
    generateFilters() {
        const { textFilter, relationshipId, organizationId } = this.state || {};
        let filters = [];

        if (organizationId != "") {
            filters.push({
                code: 'organizationId',
                isSet: true,
                logic: (x) => x.organizationId == organizationId
            });
        }

        if(relationshipId != "") {
            filters.push({
                code: 'relationshipId',
                isSet: true,
                logic: (x) => {
                    if(x?.ProjectStakeholderRelationship?.length) {
                        return x.ProjectStakeholderRelationship
                                .some(y => y.relationshipId == relationshipId);
                    }
                    return false;
                }
            });
        }

        if(textFilter != "") {
            const uppercaseFilter = textFilter.toUpperCase();
            filters.push({
                code: 'textFilter',
                isSet: true,
                logic: x => {
                    const contactName = ContactService.GetTitle(x);
                    return (
                        contactName?.toUpperCase().includes(uppercaseFilter) ||
                        x?.StakeholderAddresses?.Address?.phone?.toUpperCase().includes(uppercaseFilter) ||
                        x?.StakeholderAddresses?.Address?.email?.toUpperCase().includes(uppercaseFilter)
                    );
                }
            });
        }

        this.updateFilters(filters);
    }

    @autobind
    updateOrganizationId(event) {
        this.setState({ organizationId: event.target.value }, _ => this.generateFilters());
    }

    @autobind
    updateRelationshipId(event) {
        this.setState({ relationshipId: event.target.value }, _ => this.generateFilters());
    }

    @autobind
    updateTextFilter(event) {
        this.setState({ textFilter: event.target.value }, _ => this.generateFilters());
    }

    @autobind
    _render() {
        const { Data } = this.props;
        const { relationships, relationshipId, organizations, organizationId, textFilter } = this.state || {};

        const usedRelationshipIds = Data?.flatMap(
            item => item?.ProjectStakeholderRelationship?.map(rel => rel?.relationshipId) || []
        ) || [];

        return <Fragment>
            <Col lg={4} sm={4} xs={12} />
            <Col lg={8} sm={8} xs={12}>
                 <Row>
                     <Col xs={4} className="d-flex align-items-center">
                         {organizations.length > 1 ?
                         <FormControl
                             style={{width: '100%'}}
                             as="select"
                             placeholder={organizationId === "" ? "Select an Organization" : "Remove Filter"}
                             value={organizationId}
                             onChange={this.updateOrganizationId}
                         >
                             <option value="" key="">{organizationId === "" ? "Select an Organization" : "Remove Filter"}</option>
                            {organizations.map((org) =>
                                <option key={org.organizationId} value={org.organizationId}>{org.name}</option>
                            )}
                         </FormControl>
                         : null }
                     </Col>
                     <Col xs={4} className="d-flex align-items-center">
                         <FormControl
                             style={{width: '100%'}}
                             as="select"
                             placeholder={relationshipId === "" ? "Select A Filter": "Remove Filter"}
                             value={relationshipId}
                             onChange={this.updateRelationshipId}
                         >
                             <option value="" key="">{relationshipId === "" ? "Select A Filter": "Remove Filter"}</option>
                            {relationships
                                .filter(rel => usedRelationshipIds.includes(rel.relationshipId))
                                .map(rel =>
                                    <option key={rel.relationshipId} value={rel.relationshipId}>{rel.name}</option>
                                )}
                         </FormControl>
                     </Col>
                     <Col xs={4} className="d-flex align-items-center">
                         <FormControl
                             style={{width: '100%'}}
                             type="text"
                             value={textFilter}
                             placeholder="Search Contacts"
                             onChange={this.updateTextFilter}
                         />
                     </Col>
                 </Row>
                 <Row />
            </Col>
        </Fragment>;
    }
}
